<ng-template #settingsTemplate>
    <app-tool-setting label="Vul in">
        <app-numbers-input
            (numberChoice)="handleNumberChoice($event)"
            (undo)="handleUndo()"
            (clear)="handleClear()"
        ></app-numbers-input>
    </app-tool-setting>
</ng-template>
<ng-template #contentTemplate>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 500 96"
        style="width: 500px"
    >
        <defs>
            <style>
                .ratio-table-cls-1 {
                    fill: #eaf4fb;
                }
                .ratio-table-cls-2 {
                    font-size: 24px;
                    fill: #494949;
                    font-family: UniversLTStd, Univers LT Std;
                    letter-spacing: 0.04em;
                }
                .ratio-table-cls-3 {
                    fill: none;
                    stroke: #0091d5;
                    stroke-width: 1.5px;
                }
                .sSchema-1 {
                    fill: #fff;
                }
                .sSchema-1,
                .sSchema-2,
                .sSchema-3 {
                    stroke: #0090c9;
                    stroke-width: 1.5px;
                }
                .sSchema-2 {
                    fill: #eaf4fb;
                }
                .sSchema-3,
                .sSchema-4 {
                    fill: none;
                }
                .sSchema-4 {
                    stroke: #a1a1a1;
                }
                .sSchema-5 {
                    font-size: 28px;
                    font-family: UniversLTStd, Univers LT Std;
                }
                .sSchema-6 {
                    letter-spacing: -0.06em;
                }
            </style>
        </defs>
        <title>ATQ_DBS_verhoudingstabel</title>
        <g id="filling">
            <g class="upper">
                <g (click)="setActiveField(0)">
                    <rect
                        class="ratio-table-cls-1"
                        x="0"
                        y="0.25"
                        width="49.29"
                        height="47.75"
                    />
                    <text
                        class="ratio-table-cls-2"
                        text-anchor="middle"
                        transform="translate(24.65 35.45)"
                    >
                        {{ values[0] }}
                    </text>
                    @if (activeField === 0) {
                    <g>
                        <line
                            class="sSchema-4"
                            x1="5"
                            y1="43"
                            x2="44"
                            y2="43"
                        />
                    </g>
                    }
                </g>

                <g (click)="setActiveField(2)">
                    <rect
                        class="ratio-table-cls-1"
                        x="50"
                        y="0.25"
                        width="49.29"
                        height="47.75"
                    />
                    <text
                        class="ratio-table-cls-2"
                        text-anchor="middle"
                        transform="translate(74.65 35.45)"
                    >
                        {{ values[2] }}
                    </text>
                    @if (activeField === 2) {
                    <g>
                        <line
                            class="sSchema-4"
                            x1="55"
                            y1="43"
                            x2="94"
                            y2="43"
                        />
                    </g>
                    }
                </g>

                <g (click)="setActiveField(4)">
                    <rect
                        class="ratio-table-cls-1"
                        x="100"
                        y="0.25"
                        width="49.29"
                        height="47.75"
                    />
                    <text
                        class="ratio-table-cls-2"
                        text-anchor="middle"
                        transform="translate(124.65 35.45)"
                    >
                        {{ values[4] }}
                    </text>
                    @if (activeField === 4) {
                    <g>
                        <line
                            class="sSchema-4"
                            x1="105"
                            y1="43"
                            x2="144"
                            y2="43"
                        />
                    </g>
                    }
                </g>

                <g (click)="setActiveField(6)">
                    <rect
                        class="ratio-table-cls-1"
                        x="150"
                        y="0.25"
                        width="49.29"
                        height="47.75"
                    />
                    <text
                        class="ratio-table-cls-2"
                        text-anchor="middle"
                        transform="translate(174.65 35.45)"
                    >
                        {{ values[6] }}
                    </text>
                    @if (activeField === 6) {
                    <g>
                        <line
                            class="sSchema-4"
                            x1="155"
                            y1="43"
                            x2="194"
                            y2="43"
                        />
                    </g>
                    }
                </g>

                <g (click)="setActiveField(8)">
                    <rect
                        class="ratio-table-cls-1"
                        x="200"
                        y="0.25"
                        width="49.29"
                        height="47.75"
                    />
                    <text
                        class="ratio-table-cls-2"
                        text-anchor="middle"
                        transform="translate(224.65 35.45)"
                    >
                        {{ values[8] }}
                    </text>
                    @if (activeField === 8) {
                    <g>
                        <line
                            class="sSchema-4"
                            x1="205"
                            y1="43"
                            x2="244"
                            y2="43"
                        />
                    </g>
                    }
                </g>

                <g (click)="setActiveField(10)">
                    <rect
                        class="ratio-table-cls-1"
                        x="250"
                        y="0.25"
                        width="49.29"
                        height="47.75"
                    />
                    <text
                        class="ratio-table-cls-2"
                        text-anchor="middle"
                        transform="translate(274.65 35.45)"
                    >
                        {{ values[10] }}
                    </text>
                    @if (activeField === 10) {
                    <g>
                        <line
                            class="sSchema-4"
                            x1="255"
                            y1="43"
                            x2="294"
                            y2="43"
                        />
                    </g>
                    }
                </g>

                <g (click)="setActiveField(12)">
                    <rect
                        class="ratio-table-cls-1"
                        x="300"
                        y="0.25"
                        width="49.29"
                        height="47.75"
                    />
                    <text
                        class="ratio-table-cls-2"
                        text-anchor="middle"
                        transform="translate(324.65 35.45)"
                    >
                        {{ values[12] }}
                    </text>
                    @if (activeField === 12) {
                    <g>
                        <line
                            class="sSchema-4"
                            x1="305"
                            y1="43"
                            x2="344"
                            y2="43"
                        />
                    </g>
                    }
                </g>

                <g (click)="setActiveField(14)">
                    <rect
                        class="ratio-table-cls-1"
                        x="350"
                        y="0.25"
                        width="49.29"
                        height="47.75"
                    />
                    <text
                        class="ratio-table-cls-2"
                        text-anchor="middle"
                        transform="translate(374.65 35.45)"
                    >
                        {{ values[14] }}
                    </text>
                    @if (activeField === 14) {
                    <g>
                        <line
                            class="sSchema-4"
                            x1="355"
                            y1="43"
                            x2="394"
                            y2="43"
                        />
                    </g>
                    }
                </g>

                <g (click)="setActiveField(16)">
                    <rect
                        class="ratio-table-cls-1"
                        x="400"
                        y="0.25"
                        width="49.29"
                        height="47.75"
                    />
                    <text
                        class="ratio-table-cls-2"
                        text-anchor="middle"
                        transform="translate(424.65 35.45)"
                    >
                        {{ values[16] }}
                    </text>
                    @if (activeField === 16) {
                    <g>
                        <line
                            class="sSchema-4"
                            x1="405"
                            y1="43"
                            x2="444"
                            y2="43"
                        />
                    </g>
                    }
                </g>

                <g (click)="setActiveField(18)">
                    <rect
                        class="ratio-table-cls-1"
                        x="450"
                        y="0.25"
                        width="49.29"
                        height="47.75"
                    />
                    <text
                        class="ratio-table-cls-2"
                        text-anchor="middle"
                        transform="translate(474.65 35.45)"
                    >
                        {{ values[18] }}
                    </text>
                    @if (activeField === 18) {
                    <g>
                        <line
                            class="sSchema-4"
                            x1="455"
                            y1="43"
                            x2="494"
                            y2="43"
                        />
                    </g>
                    }
                </g>
            </g>

            <g class="lower">
                <g (click)="setActiveField(1)">
                    <rect
                        class="ratio-table-cls-1"
                        x="0"
                        y="48.25"
                        width="49.29"
                        height="47.75"
                    />
                    <text
                        class="ratio-table-cls-2"
                        text-anchor="middle"
                        transform="translate(24.65 84.45)"
                    >
                        {{ values[1] }}
                    </text>
                    @if (activeField === 1) {
                    <g>
                        <line
                            class="sSchema-4"
                            x1="5"
                            y1="91"
                            x2="44"
                            y2="91"
                        />
                    </g>
                    }
                </g>

                <g (click)="setActiveField(3)">
                    <rect
                        class="ratio-table-cls-1"
                        x="50"
                        y="48.25"
                        width="49.29"
                        height="47.75"
                    />
                    <text
                        class="ratio-table-cls-2"
                        text-anchor="middle"
                        transform="translate(74.65 84.45)"
                    >
                        {{ values[3] }}
                    </text>
                    @if (activeField === 3) {
                    <g>
                        <line
                            class="sSchema-4"
                            x1="55"
                            y1="91"
                            x2="94"
                            y2="91"
                        />
                    </g>
                    }
                </g>

                <g (click)="setActiveField(5)">
                    <rect
                        class="ratio-table-cls-1"
                        x="100"
                        y="48.25"
                        width="49.29"
                        height="47.75"
                    />
                    <text
                        class="ratio-table-cls-2"
                        text-anchor="middle"
                        transform="translate(124.65 84.45)"
                    >
                        {{ values[5] }}
                    </text>
                    @if (activeField === 5) {
                    <g>
                        <line
                            class="sSchema-4"
                            x1="105"
                            y1="91"
                            x2="144"
                            y2="91"
                        />
                    </g>
                    }
                </g>

                <g (click)="setActiveField(7)">
                    <rect
                        class="ratio-table-cls-1"
                        x="150"
                        y="48.25"
                        width="49.29"
                        height="47.75"
                    />
                    <text
                        class="ratio-table-cls-2"
                        text-anchor="middle"
                        transform="translate(174.65 84.45)"
                    >
                        {{ values[7] }}
                    </text>
                    @if (activeField === 7) {
                    <g>
                        <line
                            class="sSchema-4"
                            x1="155"
                            y1="91"
                            x2="194"
                            y2="91"
                        />
                    </g>
                    }
                </g>

                <g (click)="setActiveField(9)">
                    <rect
                        class="ratio-table-cls-1"
                        x="200"
                        y="48.25"
                        width="49.29"
                        height="47.75"
                    />
                    <text
                        class="ratio-table-cls-2"
                        text-anchor="middle"
                        transform="translate(224.65 84.45)"
                    >
                        {{ values[9] }}
                    </text>
                    @if (activeField === 9) {
                    <g>
                        <line
                            class="sSchema-4"
                            x1="205"
                            y1="91"
                            x2="244"
                            y2="91"
                        />
                    </g>
                    }
                </g>

                <g (click)="setActiveField(11)">
                    <rect
                        class="ratio-table-cls-1"
                        x="250"
                        y="48.25"
                        width="49.29"
                        height="47.75"
                    />
                    <text
                        class="ratio-table-cls-2"
                        text-anchor="middle"
                        transform="translate(274.65 84.45)"
                    >
                        {{ values[11] }}
                    </text>
                    @if (activeField === 11) {
                    <g>
                        <line
                            class="sSchema-4"
                            x1="255"
                            y1="91"
                            x2="294"
                            y2="91"
                        />
                    </g>
                    }
                </g>

                <g (click)="setActiveField(13)">
                    <rect
                        class="ratio-table-cls-1"
                        x="300"
                        y="48.25"
                        width="49.29"
                        height="47.75"
                    />
                    <text
                        class="ratio-table-cls-2"
                        text-anchor="middle"
                        transform="translate(324.65 84.45)"
                    >
                        {{ values[13] }}
                    </text>
                    @if (activeField === 13) {
                    <g>
                        <line
                            class="sSchema-4"
                            x1="305"
                            y1="91"
                            x2="344"
                            y2="91"
                        />
                    </g>
                    }
                </g>

                <g (click)="setActiveField(15)">
                    <rect
                        class="ratio-table-cls-1"
                        x="350"
                        y="48.25"
                        width="49.29"
                        height="47.75"
                    />
                    <text
                        class="ratio-table-cls-2"
                        text-anchor="middle"
                        transform="translate(374.65 84.45)"
                    >
                        {{ values[15] }}
                    </text>
                    @if (activeField === 15) {
                    <g>
                        <line
                            class="sSchema-4"
                            x1="355"
                            y1="91"
                            x2="394"
                            y2="91"
                        />
                    </g>
                    }
                </g>

                <g (click)="setActiveField(17)">
                    <rect
                        class="ratio-table-cls-1"
                        x="400"
                        y="48.25"
                        width="49.29"
                        height="47.75"
                    />
                    <text
                        class="ratio-table-cls-2"
                        text-anchor="middle"
                        transform="translate(424.65 84.45)"
                    >
                        {{ values[17] }}
                    </text>
                    @if (activeField === 17) {
                    <g>
                        <line
                            class="sSchema-4"
                            x1="405"
                            y1="91"
                            x2="444"
                            y2="91"
                        />
                    </g>
                    }
                </g>

                <g (click)="setActiveField(19)">
                    <rect
                        class="ratio-table-cls-1"
                        x="450"
                        y="48.25"
                        width="49.29"
                        height="47.75"
                    />
                    <text
                        class="ratio-table-cls-2"
                        text-anchor="middle"
                        transform="translate(474.65 84.45)"
                    >
                        {{ values[19] }}
                    </text>
                    @if (activeField === 19) {
                    <g>
                        <line
                            class="sSchema-4"
                            x1="455"
                            y1="91"
                            x2="494"
                            y2="91"
                        />
                    </g>
                    }
                </g>
            </g>
        </g>
        <g id="Laag_1" data-name="Laag 1">
            <line class="ratio-table-cls-3" y1="48" x2="500" y2="48" />
            <line class="ratio-table-cls-3" x1="49.6" x2="49.6" y2="96" />
            <line class="ratio-table-cls-3" x1="199.71" x2="199.71" y2="96" />
            <line class="ratio-table-cls-3" x1="349.82" x2="349.82" y2="96" />
            <line class="ratio-table-cls-3" x1="99.64" x2="99.64" y2="96" />
            <line class="ratio-table-cls-3" x1="249.75" x2="249.75" y2="96" />
            <line class="ratio-table-cls-3" x1="399.86" x2="399.86" y2="96" />
            <line class="ratio-table-cls-3" x1="149.67" x2="149.67" y2="96" />
            <line class="ratio-table-cls-3" x1="299.79" x2="299.79" y2="96" />
            <line class="ratio-table-cls-3" x1="449.9" x2="449.9" y2="96" />
        </g>
    </svg>
</ng-template>
